import { render, staticRenderFns } from "./DCategorySearchableSelector.vue?vue&type=template&id=6de4192c&scoped=true&"
import script from "./DCategorySearchableSelector.vue?vue&type=script&lang=js&"
export * from "./DCategorySearchableSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4192c",
  null
  
)

export default component.exports